import create from 'zustand'

export type Workspace = {
  _id: string
  name: string
  thumb?: string | File | null
  company: string
  crm: string
  phone: string
  email: string
}

type WorkspaceValues = {
  selectedWorkspace?: Workspace
  workspaceSelectorOpen: boolean
  redirectTo: string
}

type WorkspaceActions = {
  setSelectedWorkspace: (workspace?: Workspace) => void
  setWorkspaceSelectorOpen: (open: boolean) => void
  setRedirectTo: (path: string) => void
}

export type WorkspaceState = WorkspaceValues & WorkspaceActions

const initialState: WorkspaceValues = {
  workspaceSelectorOpen: false,
  redirectTo: ''
}

export const useWorkspace = create<WorkspaceState>(set => ({
  ...initialState,
  setSelectedWorkspace: (workspace?: Workspace) =>
    set(state => ({ ...state, selectedWorkspace: workspace })),
  setWorkspaceSelectorOpen: (open: boolean) =>
    set(state => ({ ...state, workspaceSelectorOpen: open })),
  setRedirectTo: (path: string) =>
    set(state => ({ ...state, redirectTo: path }))
}))
